<div id="route-window-resizable" class="pane route-window">
  <header class="pane__header pane__header--highlight">
    <div class="pane__heading--closable form--soft">
      <i class="ico-location-arrow"></i>
      <label title="{{'route.map.use-average-speed-title' | translate}}" class="custom-control custom-checkbox form-check-inline">
        <input #averageSpeed
               id= "useAverageSpeed"
               type="checkbox"
               class="custom-control-input"
               [checked]="useAverageSpeed"
               (change)="changeAverageSpeedState(averageSpeed.checked)">
        <span class="custom-control-indicator"></span>
        <span class="custom-control-description"></span>
        <span class="text-ellipsis">{{'route.map.use-average-speed' | translate}}</span>
      </label>
      <div class="switch">
        <a class="switch__item"
           (click)="switchRoute()"
           [ngClass]="{'switch__item--active': this.lightRoute}">
          <i class="ico-car"></i>
        </a>
        <a class="switch__item"
           (click)="switchRoute()"
           [ngClass]="{'switch__item--active': !this.lightRoute}">
          <i class="ico-truck"></i>
        </a>
      </div>
      <a class="pane__close" (click)="close()"><i class="ico-close"></i></a>
    </div>
  </header>
  <div *ngIf="routeNotAvailable" class="pane__content">
    <div class="alert alert-warning notification">
      <strong>{{'route.map.warning' | translate}}</strong> {{'route.map.impossible' |
      translate}}
    </div>
  </div>
  <div class="pane__content widget-body" [ngClass]="{'small-plan': small, 'warning-open': routeNotAvailable}">
    <div class="task-list--plan route-plan">
      <div class="drag-list list-boundary"
           cdkDropList
           (cdkDropListDropped)="drop($event)"
           [cdkDropListDisabled]="dragDisabled">
        <div
          class="task-point input-group route-point drag-box"
          *ngFor="let viaPoint of displayedPoints; let idx = index"
          cdkDragBoundary=".list-boundary" cdkDragLockAxis="y" cdkDrag>
          <div class="task-point__status">
            <div class="letter">{{alphabetList[idx]}}</div>
            <i class="ico-arrows-v"></i>
          </div>
          <input type="text" id="via-{{idx}}" (focus)="focusInput(idx)"
                 placeholder="{{'route.map.via-point' | translate}}"
                 [value]="viaPoint.name"
                 maxlength="255"
                 class="task-point__input form-control"
                 (keydown)="onKeydown($event, idx)"
                 appAutocompleteOff />
          <div class="task-autocomplete">
            <div id="item-{{idx}}-{{index}}"
                 [ngClass]="dropDownIndex === index ? 'selected-route__result' : ''"
                 class="task-autocomplete__item task-autocomplete__item--{{index}}"
                 *ngFor="let result of searchResults.get(idx); let index = index"
                 (click)="setViaPoint(result, idx)">
              {{result.name}}
              <input type="hidden" value="{{result.name}}">
            </div>
            <div id="show-more-{{idx}}" class="show-more hidden" (click)="showMore(idx, $event)">
              {{'route.map.showMore' | translate}}
            </div>
          </div>
          <div class="task-point__action" (click)="remove(idx)">
            <i class="ico-trash"></i>
          </div>
        </div>
        <div class="task-list__add">
          <a (click)="addViaPoint()"
             class="item__action--tertiary">
            <i class="ico-plus"></i>
          </a>
        </div>

        <section class="route-parameters">
          <h4 *ngIf="hasHeavyTracking" class="route-parameters__header" (click)="changeState()">
            <i title="{{'tasks.manager.form.expand' | translate}}"
               [ngClass]="{'ico-plus-square': !paramsOpened, 'ico-minus-square': paramsOpened}"></i>
            <span>{{'route.planning.routeCalcParams' | translate}}</span>
          </h4>
          <div [formGroup]="olRouteForm" class="calc-params form--soft" [ngClass]="{'opened': paramsOpened}">
            <div class="truck-parameters form__columns--irregular">
              <section>
                <div class="input-group" [ngbTooltip]="'proTasks.form.properties.routeParams.weight' | translate">
                  <div class="input-group-prepend">
                    <i class="ico-scales"></i>
                  </div>
                  <input class="form-control weight"
                         type="number"
                         formControlName="weight">
                  <div class="input-group-append">
                    <span class="input-group-text">{{'unit.kg' | translate}}</span>
                  </div>
                </div>
                <div class="input-group" [ngbTooltip]="'proTasks.form.properties.routeParams.height' | translate">
                  <div class="input-group-prepend">
                    <i class="ico-arrows-v"></i>
                  </div>
                  <input
                         class="form-control height"
                         type="number"
                         formControlName="height">
                  <div class="input-group-append">
                    <span class="input-group-text">{{'unit.m' | translate}}</span>
                  </div>
                </div>
                <div class="input-group" [ngbTooltip]="'proTasks.form.properties.routeParams.width' | translate">
                  <div class="input-group-prepend">
                    <i class="ico-arrows-h"></i>
                  </div>
                  <input
                         class="form-control width"
                         type="number"
                         formControlName="width">
                  <div class="input-group-append">
                    <span class="input-group-text">m</span>
                  </div>
                </div>
              </section>
              <section class="avoids">
                <h5>{{'tasks.manager.form.avoid' | translate}}</h5>
                <div *ngFor="let avoid of routeAvoids">
                  <label class="custom-control custom-checkbox">
                    <input
                      [attr.id]="avoid"
                      [value]="avoid"
                      type="checkbox"
                      (change)="addOrRemoveAvoid(avoid, $event)"
                      [checked]="avoids ? avoids.includes(avoid) : false"
                      class="custom-control-input checkbox-danger"/>
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">
                      {{'tasks.manager.form.calculations.' + avoid | translate}}
                    </span>
                  </label>
                </div>
              </section>
              <section class="strategies__type">
                <h5>{{'tasks.manager.form.strategies' | translate}}</h5>
                <div class="switch-field">
                  <label class="switch-control" *ngFor="let strategyItem of calcStrategies">
                    <input type="radio"
                           id="strategy"
                           name="strategy"
                           formControlName="strategy"
                           [value]="strategyItem"
                           class="switch-input">
                    <span class="switch-label">
                      {{'tasks.manager.form.calculations.' + strategyItem | translate}}
                    </span>
                  </label>
                </div>
              </section>
            </div>
            <h4 class="route-parameters__header">
              <span>{{'route.planning.priceCalcParams' | translate}}</span>
            </h4>
            <div class="truck-parameters truck-parameters--price form__columns--irregular">
              <section>
                <div class="input-group" [ngbTooltip]="'route.planning.averageFuelPrice' | translate">
                  <div class="input-group-prepend">
                    <i class="ico-money"></i>
                  </div>
                  <input class="form-control"
                         type="number"
                         formControlName="averageFuelPrice">
                  <div class="input-group-append">
                    <span class="input-group-text">{{'unit.eurL' | translate}}</span>
                  </div>
                </div>
              </section>
              <section>
                <div class="input-group" [ngbTooltip]="'route.planning.averageTruckRentPrice' | translate">
                  <div class="input-group-prepend">
                    <i class="ico-truck-head"></i>
                  </div>
                  <input class="form-control"
                         type="number"
                         formControlName="averageTruckRentPrice">
                  <div class="input-group-append">
                    <span class="input-group-text">{{'unit.eurH' | translate}}</span>
                  </div>
                </div>
              </section>
              <section>
                <div class="input-group" [ngbTooltip]="'route.planning.fuelUsageFor100km' | translate">
                  <div class="input-group-prepend">
                    <i class="ico-fuel"></i>
                  </div>
                  <input class="form-control"
                         type="number"
                         formControlName="fuelUsageFor100km">
                  <div class="input-group-append">
                    <span class="input-group-text">{{'unit.lp100km' | translate}}</span>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
        <button class="form__action--primary" type="button" (click)="calculate()">
          <i class="ico-location-arrow"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="pane__footer" *ngIf="calculatedRoute">
    <div class="task-totals route-calc">
      <dl>
        <dt><i class="ico-road sz-s" aria-hidden="true"></i></dt>
        <dd><strong>{{calculatedRoute.distance | distance}}</strong></dd>
      </dl>
      <dl>
        <dt><i class="ico-truck sz-s" aria-hidden="true"></i></dt>
        <dd>
          <strong>{{(useAverageSpeed ? avgCalculatedRoute.duration : calculatedRoute.duration) | duration}}</strong>
        </dd>
      </dl>
      <dl placement='top-right'
          [ngbTooltip]="priceExpl">
        <dt><i class="ico-money sz-s"></i></dt>
        <ng-container *ngIf="tollPrice != null">
          <dd><strong>{{tollPrice.totalCost | price}}</strong></dd>
        </ng-container>
        <ng-template #priceExpl>
          <div class="cost-per-country" *ngIf="tollPrice != null">
            {{'route.map.toll-prices' | translate}}:
            <p *ngFor="let tolls of tollPrice.countryTolls">
              <strong>{{tolls.country}}:</strong> {{tolls.amountInTargetCurrency  | price }}
            </p>
          </div>
        </ng-template>
      </dl>
      <dl [ngbTooltip]="'route.planning.averageFuelPriceTooltip' | translate">
        <dt><i class="ico-fuel" aria-hidden="true"></i></dt>
        <dd><strong>{{calculatedRoute.fuelPrice | price}}</strong></dd>
      </dl>
      <dl [ngbTooltip]="'route.planning.averageTruckRentPriceTooltip' | translate">
        <dt><i class="ico-clock sz-s" aria-hidden="true"></i></dt>
        <dd>
          <strong>
            {{(useAverageSpeed ? avgCalculatedRoute.truckOperatingCost : calculatedRoute.truckOperatingCost) | price}}
          </strong>
        </dd>
      </dl>
      <dl [ngbTooltip]="'route.planning.totalRoutePrice' | translate">
        <dt><i class="ico-coin" aria-hidden="true"></i></dt>
        <dd><strong>{{getTotalRoutePrice() | price}}</strong></dd>
      </dl>
    </div>
    <ng-container  *ngIf="olRoute.size > 1">
      <div *ngFor="let leg of getRouteLegs(); let idx = index" class="task-totals segment-details">
        <ng-container *ngIf="leg.distance && leg.duration">
          <dl>
            <dt><span class="segment__letter">{{alphabetList[idx]}}</span> <i class="ico-arrow-right"></i> <span class="segment__letter">{{alphabetList[idx + 1]}}</span></dt>
          </dl>
          <dl>
            <dt><i class="ico-road" aria-hidden="true"></i></dt>
            <dd>{{leg.distance | distance}}</dd>
          </dl>
          <dl>
            <dt><i class="ico-truck" aria-hidden="true"></i></dt>
            <dd>{{leg.duration | duration}}</dd>
          </dl>
          <dl>
            <dt><i class="ico-fuel" aria-hidden="true"></i></dt>
            <dd>{{leg.fuelPrice | price}}</dd>
          </dl>
          <dl>
            <dt><i class="ico-clock" aria-hidden="true"></i></dt>
            <dd>{{leg.truckOperatingCost | price}}</dd>
          </dl>
        </ng-container>
      </div>
    </ng-container >
  </div>
</div>
<app-polyline-interactions [map]="map"
                           [polylineLayer]="routeLayer"
                           [polylineMapType]="'route'"
                           [waypointMapType]="'route-point'"
                           [originMapType]="'route-origin-marker'"
                           [destinationMapTye]="'route-destination-marker'"
                           [activeRoute]="activeRoute"
                           [activeRouteRequest]="routeRequest"
                           [activeRoutePolyline]="routePolyline"
                           (recalculateRoute)="recalculate()">
</app-polyline-interactions>
